import api from "./api";

export const getBookingCart = async (customerId) => {
  return api
    .get({
      endpoint: `/own/cart/list/venue?customerId=${customerId}`,
      port: process.env.REACT_APP_PORT_CART,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
